import React from 'react';
import CreateMaterialModal from './CreateMaterialModal';
import MaterialDetailModal from './MaterialDetailModal';

// Component that renders all material-related modals
const MaterialModals: React.FC = () => {
  return (
    <>
      <CreateMaterialModal />
      <MaterialDetailModal />
    </>
  );
};

export default MaterialModals;

// Export individual components
export {
  CreateMaterialModal,
  MaterialDetailModal,
};
